import { ref } from 'vue';
import api from '../api';
import { GetOrganizationUsersResponse, GetOrganizationUsersRequest } from '@ilteducation/customer-mgmt-types';

export type SearchOrganizationUserSoryBy = GetOrganizationUsersRequest['sortBy'];

export const useGetOrganizationUsers = () => {
  const users = ref<GetOrganizationUsersResponse | null>();

  const loadUsers = async (organizationUid: string, opts?: Omit<GetOrganizationUsersRequest, 'organizationUid'>) => {
    const response = await api.organization
      .users(organizationUid, opts ?? {})
      .then((res) => res.data)
      .catch((error) => {
        console.error('Failed to load users', error);
        // TODO: error handling
        return { data: [], meta: { totalItems: 0 } };
      });

    users.value = response;

    return users.value;
  };

  return {
    users,
    loadUsers,
  };
};
